"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.erc20SignatureInfo = exports.hydrate = exports.preload = exports.fetchERC20Tokens = exports.modes = void 0;
// handle erc20 feature others than send.
const ethereumjs_abi_1 = __importDefault(require("ethereumjs-abi"));
const invariant_1 = __importDefault(require("invariant"));
const eip55_1 = __importDefault(require("eip55"));
const bignumber_js_1 = require("bignumber.js");
const errors_1 = require("@ledgerhq/errors");
const cryptoassets_1 = require("@ledgerhq/cryptoassets");
const network_1 = __importDefault(require("@ledgerhq/live-network/network"));
const cache_1 = require("@ledgerhq/live-network/cache");
const transaction_1 = require("../transaction");
const account_1 = require("../../../account");
const currencies_1 = require("../../../currencies");
const live_env_1 = require("@ledgerhq/live-env");
const logs_1 = require("@ledgerhq/logs");
const erc20_1 = require("@ledgerhq/hw-app-eth/erc20");
const infinite = new bignumber_js_1.BigNumber(2).pow(256).minus(1);
function contractField(transaction) {
    return {
        type: "text",
        label: "Address",
        value: transaction.recipient,
    };
}
/**
 * "erc20.approve" allows a "spender" (e.g. contract address) to consume some erc20 tokens.
 * transaction params:
 * - transaction.recipient address of the spender
 * - transaction.amount in the token unit to allow
 * - transaction.useAllAmount intend to allow infinite amount (setting a very high value)
 */
const erc20approve = {
    fillTransactionStatus(a, t, result) {
        if (!t.useAllAmount) {
            if (t.amount.eq(0)) {
                result.errors.amount = new errors_1.AmountRequired();
            }
        }
        result.amount = t.amount;
    },
    fillTransactionData(a, t, tx) {
        const subAccount = (0, transaction_1.inferTokenAccount)(a, t);
        (0, invariant_1.default)(subAccount, "sub account missing");
        // FIXME: make sure it doesn't break
        if (!subAccount)
            throw new Error("sub account missing");
        const recipient = eip55_1.default.encode(t.recipient);
        let amount;
        if (t.useAllAmount) {
            amount = infinite;
        }
        else {
            (0, invariant_1.default)(t.amount, "amount missing");
            amount = new bignumber_js_1.BigNumber(t.amount);
        }
        const data = ethereumjs_abi_1.default.simpleEncode("approve(address,uint256)", recipient, amount.toString(10));
        tx.data = "0x" + data.toString("hex");
        tx.to = subAccount.token.contractAddress;
        tx.value = "0x00";
        return {
            erc20contracts: [recipient],
        };
    },
    fillDeviceTransactionConfig({ transaction, account }, fields) {
        fields.push({
            type: "text",
            label: "Type",
            value: "Approve",
        });
        if (transaction.useAllAmount) {
            fields.push({
                type: "text",
                label: "Amount",
                value: "Unlimited " + (0, account_1.getAccountCurrency)(account).ticker,
            });
        }
        else {
            // TODO amount should be just text in future
            fields.push({
                type: "amount",
                label: "Amount",
            });
        }
        fields.push(contractField(transaction));
    },
    fillOptimisticOperation(_account, _transaction, operation) {
        operation.type = "FEES";
    },
    getResolutionConfig: () => ({ erc20: true, externalPlugins: true }),
};
exports.modes = {
    "erc20.approve": erc20approve,
};
exports.fetchERC20Tokens = (0, cache_1.makeLRUCache)(() => __awaiter(void 0, void 0, void 0, function* () {
    let tokens;
    try {
        const { data } = yield (0, network_1.default)({
            url: `${(0, live_env_1.getEnv)("DYNAMIC_CAL_BASE_URL")}/erc20.json`,
        });
        if (!data || !Array.isArray(data)) {
            throw new Error("ERC20.json file was malformed");
        }
        tokens = data;
    }
    catch (e) {
        (0, logs_1.log)("preload-erc20", `failed to preload erc20 ${e.toString()}`);
        tokens = [];
    }
    return tokens;
}), () => "erc20-tokens", {
    ttl: 6 * 60 * 60 * 1000,
});
function preload(currency) {
    return __awaiter(this, void 0, void 0, function* () {
        if (currency.id !== "ethereum") {
            return Promise.resolve(null);
        }
        try {
            const tokens = yield (0, exports.fetchERC20Tokens)();
            (0, currencies_1.addTokens)(tokens.map(cryptoassets_1.convertERC20));
            return tokens;
        }
        catch (e) {
            (0, logs_1.log)("Ethereum Family", "Error while adding tokens in preload", e);
            return [];
        }
    });
}
exports.preload = preload;
function hydrate(value, currency) {
    if (currency.id !== "ethereum" || !value)
        return;
    (0, currencies_1.addTokens)(value.map(cryptoassets_1.convertERC20));
    (0, logs_1.log)("ethereum/preload", "hydrate " + value.length + " tokens");
}
exports.hydrate = hydrate;
exports.erc20SignatureInfo = (0, cache_1.makeLRUCache)((loadConfig) => __awaiter(void 0, void 0, void 0, function* () { return (0, erc20_1.findERC20SignaturesInfo)(loadConfig); }), () => "erc20-signatures");
//# sourceMappingURL=erc20.js.map